export const breakpoints = {
    xs: '380px',
    risk_assessment_xl: '1350px',
}
